
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getWithdrawInfo } from '@/api/task/withdraw'
import { notifiedStatus, upStreamStatusList } from '@/utils/constant'
@Component({
  name: 'orderDetail',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  private tabName: string = 'attach'
  private orderTypeList = upStreamStatusList
  private notifiedStatus = notifiedStatus

  private async init () {}

  mounted () {
    this.init()
  }
}
